import type { RootState } from '../store'
import type { Comment } from '../../Models/Task'

export const selectCommentsByTaskId =
  (taskId: string | undefined) =>
  (state: RootState): Comment[] =>
    taskId ? state.comments.byTaskId[taskId] ?? [] : []

export const selectCommentsStatus = (state: RootState) => state.comments.status

export const selectCommentsError = (state: RootState) => state.comments.error
